import React from 'react';
import { token } from '@atlaskit/tokens';
import { Box } from '@atlaskit/primitives/compiled';
import { cssMap } from '@atlaskit/css';
import { defineMessages, useIntl } from 'react-intl-next';

// eslint-disable-next-line check-choreographer-usage/no-import-in-product-messages-without-choreographer
import Modal, { CloseButton } from '@atlaskit/modal-dialog';

const headerStyles = cssMap({
	header: {
		display: 'flex',
		alignItems: 'center',
		justifyContent: 'space-between',
		flexDirection: 'row-reverse',
		position: 'absolute',
		top: 0,
		right: token('space.negative.400'),
		left: 0,
		zIndex: 1,
	},
	container: {
		position: 'relative',
		height: '100%',
	},
});

const i18n = defineMessages({
	closeModal: {
		id: 'premium-trial.learn-more.video.close-modal.label',
		description: 'Label to describe close modal button for closing the video modal',
		defaultMessage: 'Close video modal',
	},
});

type LearnMoreVideoModalProps = {
	onClose: () => void;
};

export const LearnMoreVideoModal = ({ onClose }: LearnMoreVideoModalProps) => {
	const { formatMessage } = useIntl();
	return (
		<Modal onClose={onClose} width="large" height="474px">
			<Box xcss={headerStyles.container}>
				<Box xcss={headerStyles.header}>
					<CloseButton
						onClick={onClose}
						label={formatMessage(i18n.closeModal)}
						testId="learn-more-video-modal-close-button"
					/>
				</Box>
				<iframe
					width="100%"
					height="100%"
					src="https://www.youtube.com/embed/UYYe0Qbs9fs?si=PtVPpFx_Jiued9de"
					frameBorder="0"
					allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share; fullscreen"
					title="Explore Confluence Premium"
				/>
			</Box>
		</Modal>
	);
};
